import { PATH } from '../../../../routes/constant'

export interface INavConfig {
  title: string
  path: string
}

function navConfigHome (): INavConfig[] {
  return [
    {
      title: 'Home',
      path: PATH.HOME
    }
  ]
}

export default navConfigHome
